import React from "react";
import { ProgressTracker } from "@atlaskit/progress-tracker";
import { wargameExerciseStatuses } from "../../../models";
export var ExerciseProgressTracker = function (_a) {
    var currentStatus = _a.currentStatus;
    var allStatuses = Object.values(wargameExerciseStatuses).filter(function (_a) {
        var name = _a.name;
        return name !== wargameExerciseStatuses.cancelled.name;
    });
    var currentStatusIndex = allStatuses.findIndex(function (_a) {
        var name = _a.name;
        return name === currentStatus;
    });
    var stages = allStatuses.map(function (_a, statusIndex) {
        var label = _a.label;
        var percentageComplete = statusIndex < currentStatusIndex ? 100 : 0;
        var stageStatus = statusIndex < currentStatusIndex
            ? "visited"
            : statusIndex === currentStatusIndex
                ? "current"
                : "unvisited";
        return {
            id: label,
            label: label,
            percentageComplete: percentageComplete,
            status: stageStatus
        };
    });
    return React.createElement(ProgressTracker, { items: stages });
};
